import React, { useEffect } from "react";
import { motion } from "motion/react";
import { Link, useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.pathname !== "/404") navigate("/404");
  }, []);

  return (
    <div className="max-w-screen-2xl mx-auto px-5 lg:px-20 mb-8 sm:mb-20">
      <div className="lg:h-[450px] bg-[#e6e0ff] lg:bg-transparent lg:bg-bg2 bg-cover lg:bg-contain bg-no-repeat xl:bg-cover lg:-mt-20 xl:-mt-28 relative rounded-b-[50px] rounded-t-[50px] lg:rounded-t-none">
        <div className="w-full h-full flex flex-col justify-center xl:justify-end px-4 xl:px-10 pb-8 xl:pb-14 pt-8 lg:pt-0">
          <div className="flex flex-col lg:flex-row justify-between">
            <div className="lg:w-[50%]">
              <motion.div
                initial={{ y: -100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="py-3 px-4 montserrat-medium text-primary bg-white rounded-full w-32 flex justify-center mb-5"
              >
                ERROR
              </motion.div>
              <motion.h1
                initial={{ y: -100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
                className="text-secondary text-4xl xl:text-5xl montserrat-regular mb-4 lg:mb-0"
              >
                <span className="montserrat-semibold text-primary">
                  404 - Page
                </span>{" "}
                Not{" "}
                <span className="montserrat-semibold text-primary">Found</span>
              </motion.h1>
            </div>
            <div className="lg:w-[40%] flex items-end">
              <motion.p
                initial={{ y: -100, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 1 }}
                viewport={{ once: true }}
                className="montserrat-regular text-secondary"
              >
                The page you’re looking for doesn’t exist. Return to the{" "}
                <Link to="/">
                  <span className="montserrat-semibold cursor-pointer text-primary">
                    Home Page,
                  </span>{" "}
                </Link>
                visit the
                <Link to="/about-us">
                  <span className="montserrat-semibold cursor-pointer text-primary">
                    About Me
                  </span>{" "}
                </Link>
                page, or check our{" "}
                <Link to="/faq">
                  <span className="montserrat-semibold cursor-pointer text-primary">
                    FAQs.
                  </span>
                </Link>
                <br /> Need help?{" "}
                <Link to="/contact">
                  <span className="montserrat-semibold cursor-pointer text-primary">
                    Contact Me.
                  </span>
                </Link>
              </motion.p>
            </div>
          </div>
        </div>
        <a
          href="/contact"
          className="hidden lg:block bg-[#E9FF7A] py-3 px-7 absolute top-3 xl:top-10 right-5 xl:right-20 2xl:right-24 montserrat-medium rounded-full text-xl z-30"
        >
          Contact Me
        </a>
      </div>
    </div>
  );
};

export default ErrorPage;
